import { jsx as e } from "react/jsx-runtime";
import { useIsInverseVariant as s } from "./theme-variant-context.js";
import { variants as i } from "./divider.css-mistica.js";
const t = ()=>{
    const r = s();
    return /* @__PURE__ */ e("div", {
        className: i[r ? "inverse" : "default"]
    });
}, m = t;
export { m as default };
